import type { ApiResponseBody } from "@/lib/api/api-type-helper";

export type UserSession = ApiResponseBody<"/v2/session", "get">;

export const MfaResNextStep = {
  signInStep: {
    CONFIRM_SIGN_IN_WITH_EMAIL_CODE: "CONFIRM_SIGN_IN_WITH_EMAIL_CODE",
  },
} as const;

export type SignInForm = {
  username: string;
  password: string;
};

export type ConfirmSignInForm = {
  challengeResponse: string;
};

export type ConfirmResetPasswordForm = {
  username: string;
  confirmationCode: string;
  newPassword: string;
};

export type AccessToken = string & { readonly brand: "AccessToken" };
export type IdToken = string & { readonly brand: "IdToken" };
